/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from 'react';
import { DatePicker, Input, Modal, TextArea, useForm } from 'linkwithus';
import './styles.scss';
import { motion } from 'framer-motion';
import config from 'config';
import { notification } from 'antd';
import { useTranslation } from 'react-i18next';
import SiteButton from 'components/SiteButton';
import FileUploader from 'components/FileUploader';
import moment from 'moment';
import {
    ModalMode,
    IEditCurrentPresidentForm,
    IEditCurrentPresidentModalProps,
} from './interface';
import { contentSettingsModalMotion } from './animation';

function EditCurrentPresidentModal({
    modalVisibility,
    close,
    item,
    mode = ModalMode.Edit,
    updateList,
}: IEditCurrentPresidentModalProps) {
    const { t } = useTranslation();
    const [imageUrl, setImageUrl] = useState<string>();
    const [imageVisibility, setImageVisibility] = useState(false);

    const { register, form, submit, updateForm, setForm } =
        useForm<IEditCurrentPresidentForm>({
            url: `/presidents/${
                mode === ModalMode.Edit && item
                    ? item.Id
                    : '?currentPresident=true'
            }`,
            type: mode === ModalMode.Edit ? 'PUT' : 'POST',
            onSuccess: () => {
                notification.success({
                    message: t('general.SUCCESS'),
                    description: t(
                        `countyPage.${
                            mode === ModalMode.Edit
                                ? 'INFO_CHANGED_WITH_SUCESS'
                                : 'PRESIDENT_CREATED_WITH_SUCCESS'
                        }`,
                    ),
                });
                updateList();
                close();
            },
            onError: (data, error: any) => {
                const errorCode = Number(error.errorCode) || 0;
                notification.error({
                    message: t(`general.ERROR`),
                    description: t(`errors.${errorCode}`),
                });
                updateList();
                close();
            },
            resolveData(rawForm) {
                const data = new FormData();
                Object.keys(rawForm).forEach(key => {
                    if (key === 'photo') {
                        rawForm.photo.forEach((f: any) => {
                            data.append('photo', f as any);
                        });
                    } else
                        data.append(
                            key,
                            rawForm[
                                key as keyof IEditCurrentPresidentForm
                            ] as any,
                        );
                });
                return data;
            },
        });

    useEffect(() => {
        if (modalVisibility && mode === ModalMode.Edit && !item) {
            close();
        }
        if (modalVisibility && mode === ModalMode.Edit && item) {
            const currentDate = new Date();
            updateForm('name', item.Name);
            updateForm('description', item.Info);
            updateForm('mandateStartDate', moment(item.MandateStartDate));
            setImageUrl(
                `${config.API_URL}/presidents/images/${item.Id}?date=${currentDate}`,
            );
            setTimeout(() => {
                setImageVisibility(true);
            }, 100);
        }
        if (!modalVisibility) {
            setForm({
                mandateStartDate: null,
            });
            setImageVisibility(false);
        }
        if (modalVisibility && mode === ModalMode.Create) {
            setImageUrl(undefined);
            setTimeout(() => {
                setImageVisibility(true);
            }, 100);
        }
    }, [modalVisibility]);

    return (
        <Modal
            visible={modalVisibility}
            close={close}
            className='edit-current-president-modal'
            width={700}
        >
            <motion.div
                {...contentSettingsModalMotion}
                className='edit-current-president-modal__content'
            >
                <p className='edit-current-president-modal__content__title'>
                    {t(
                        `countyPage.${
                            mode === ModalMode.Edit
                                ? 'EDIT_PRESIDENT'
                                : 'NEW_PRESIDENT'
                        }`,
                    )}
                </p>
                <div className='edit-current-president-modal__content__body'>
                    <div className='edit-current-president-modal__content__body__img'>
                        {imageVisibility && (
                            <FileUploader
                                {...register('photo')}
                                initial={imageUrl}
                                className='circular'
                            />
                        )}
                    </div>
                    <p className='edit-current-president-modal__content__body__label'>
                        {t('form.NAME')}
                    </p>
                    <Input
                        {...register('name', {
                            required: true,
                            resolveError: () =>
                                `${t('form.NAME')} ${t('form.REQUIRED_FIELD')}`,
                        })}
                        className='edit-current-president-modal__content__body__field'
                    />
                    <p className='edit-current-president-modal__content__body__label'>
                        {t('countyPage.TERM_START_DATE')}
                    </p>
                    <DatePicker
                        {...register('mandateStartDate')}
                        placeholder={t('countyPage.DATE')}
                        className='edit-current-president-modal__content__body__field'
                    />
                    <p className='edit-current-president-modal__content__body__label'>
                        {t('countyPage.ABOUT_PRESIDENT')}
                    </p>
                    <TextArea
                        {...register('description', {
                            required: true,
                            resolveError: () =>
                                `${t('countyPage.ABOUT_PRESIDENT')} ${t(
                                    'form.REQUIRED_FIELD',
                                )}`,
                        })}
                        autoSize
                        onPressEnter={() => {
                            //
                        }}
                        className='edit-current-president-modal__content__body__field president-text-area'
                    />
                </div>
                <div className='edit-current-president-modal__content__footer'>
                    <SiteButton
                        text={t('general.CANCEL')}
                        type='primary'
                        className='edit-current-president-modal__content__footer__button grey'
                        onClick={close}
                    />
                    <SiteButton
                        text={t('form.SAVE_CHANGES')}
                        type='primary'
                        className='edit-current-president-modal__content__footer__button'
                        onClick={submit}
                        disabled={
                            mode === ModalMode.Create &&
                            (!form.name ||
                                !form.mandateStartDate ||
                                !form.photo ||
                                !form.description ||
                                (form.photo &&
                                    Array.isArray(form.photo) &&
                                    !(form.photo.length > 0)))
                        }
                    />
                </div>
            </motion.div>
        </Modal>
    );
}

export default EditCurrentPresidentModal;
